class VideoBanner {
  constructor() {
    this.videos = document.querySelectorAll('.js-media-banner-video');
    this.init();
  }

  init() {
    this.videos.forEach(video => {
      this.setupVideo(video);
    });
  }

  setupVideo(video) {
    const container = video.closest('.media-banner__media');
    if (!container) return;

    const controls = {
      play: container.querySelector('.js-video-play'),
      pause: container.querySelector('.js-video-pause'),
      mute: container.querySelector('.js-video-mute'),
      unmute: container.querySelector('.js-video-unmute')
    };
  
    
    const poster = container.querySelector('.media-banner__poster');

    // Ensure video is properly configured for autoplay
    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    // Setup control buttons
    this.setupControls(video, controls);

    // Setup lazy loading with Intersection Observer
    this.setupLazyLoading(video, poster);
  }

  setupControls(video, controls) {
    // Play button
    if (controls.play) {
      controls.play.addEventListener('click', () => {
        video.play().catch(error => {
          console.error('Error playing video:', error);
        });
        this.togglePlayPause(controls.play, controls.pause);
      });
    }

    // Pause button
    if (controls.pause) {
      controls.pause.addEventListener('click', () => {
        video.pause();
        this.togglePlayPause(controls.pause, controls.play);
      });
    }

    // Mute button
    if (controls.mute) {
      controls.mute.addEventListener('click', () => {
        video.muted = false;
        this.toggleMuteUnmute(controls.mute, controls.unmute);
      });
    }

    // Unmute button
    if (controls.unmute) {
      controls.unmute.addEventListener('click', () => {
        video.muted = true;
        this.toggleMuteUnmute(controls.unmute, controls.mute);
      });
    }

    // Video state change events
    video.addEventListener('play', () => {
      this.togglePlayPause(controls.play, controls.pause);
    });

    video.addEventListener('pause', () => {
      this.togglePlayPause(controls.pause, controls.play);
    });

    video.addEventListener('volumechange', () => {
      if (video.muted) {
        this.toggleMuteUnmute(controls.unmute, controls.mute);
      } else {
        this.toggleMuteUnmute(controls.mute, controls.unmute);
      }
    });
  }

  togglePlayPause(hideButton, showButton) {
    hideButton?.classList.add('hide');
    showButton?.classList.remove('hide');
  }

  toggleMuteUnmute(hideButton, showButton) {
    hideButton?.classList.add('hide');
    showButton?.classList.remove('hide');
  }

  setupLazyLoading(video, poster) {
    if (!('IntersectionObserver' in window)) return;
    
   
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
     
          
          // Handle video sources if using data-src
          for (let source of entry.target.children) {
            if (source.tagName === 'SOURCE' && source.dataset.src) {
              console.log('Setting source:', source.dataset.src);
              source.src = source.dataset.src;
            }
          }
          
          // Load and play video
          entry.target.load();
          entry.target.classList.remove('lazy');
      

          // Auto-play when visible
          entry.target.muted = true;
          entry.target.setAttribute('muted', 'muted');
          entry.target.setAttribute('playsinline', 'playsinline');
          
          // Try immediate play first
          entry.target.play().then(() => {
            console.log('Video playing successfully!');
          }).catch(error => {
            console.error('Immediate play failed, trying with canplaythrough:', error);
            
            // Fallback: wait for video to be ready
            entry.target.addEventListener('canplaythrough', function() {
              console.log('Video can play through, attempting play...');
              entry.target.play().then(() => {
                console.log('Video playing after canplaythrough!');
              }).catch(playError => {
                console.error('Play failed after canplaythrough:', playError);
              });
            }, { once: true });
          });
          
          // Hide poster image
          if (poster) {
            poster.classList.add('hide');
          }

          // Unobserve after loading
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });
    
    observer.observe(video);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new VideoBanner();
});

// Initialize for Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.js-media-banner-video')) {
    new VideoBanner();
  }
});
 